interface WorkerDeviceUseProps {}

const useDeviceWorker = (props: WorkerDeviceUseProps) => {
  return {}
}
export default useDeviceWorker
